<template>
  <div class="pixiapp w-full h-full">
    <a class="text-white" href="https://www.pixiplayground.com/#/edit/ZsVBsFY2PQLj6_P0yN6_e">lol</a>
  </div>
</template>
<script>
import PixiAppPool from '@/play/components/pixiAppPool.js';
import * as PIXI from 'pixi.js-legacy';
window.PIXI = PIXI;
const pixiAppPool = new PixiAppPool();
const util = require('../../play/game/util.js');

const layer1 = {
  gridx:1,
  gridy:1,
  spritesheets:[
    "spritesheet_tilesBlue.json",
    "voxelTiles_sheet2.json"
  ],
  frames: [
    {spritesheet:2,name:"voxelTile_03.png"},
    {spritesheet:2,name:"voxelTile_04.png"},
    {spritesheet:2,name:"voxelTile_05.png"},
    {spritesheet:2,name:"voxelTile_06.png"},
    {spritesheet:2,name:"voxelTile_01.png"},
    {spritesheet:2,name:"voxelTile_02.png"},
  ],
  tiles:[
    0,1,2,3,4,5,6,
    0,1,2,3,4,5,6,
    0,1,2,3,4,5,6,
    0,1,2,3,4,5,6
  ],
  width:7,
  height:7
}


class PbcLayer extends PIXI.Container {
  constructor(resources, layer) {
    super();
    this.layer = layer;
    this.resources = resources;

    const textures = layer.spritesheets.map( (spritesheet) => {
      return resources[spritesheet + "_image"].texture;
    });

    this.tilemap = new PIXI.tilemap.CompositeRectTileLayer(0, textures);
    this.addChild(this.tilemap);
  }

  update() {
    var size = 64;
    // bah, im too lazy, i just want to specify filenames from atlas
    const width = this.layer.width;
    const height = this.layer.height;
    for (var j=height-1;j>=0;j--)
        for (var i=0;i<height;i++) {

          const tile = this.layer.tiles[j * width + i];
          if (tile > 0) {
            const frame = this.layer.frames[tile - 1];
            console.log('have frame', frame);
            this.tilemap.addFrame(frame.name, i*size, j*size);
          }
        }

      // if you are lawful citizen, please use textures from the loader
      //var textures = resources.atlas.textures;
      //tilemap.addFrame(textures["tileBlue_03.png"], 2*size, 2*size);
      //tilemap.addFrame(textures["tileBlue_21.png"], 2*size, 3*size);

      //this.pixiApp.renderer.render(tilemap);
  }

}

export default {
  mounted() {
    this.pixiApp = pixiAppPool.take('test', this.$el, {
      width: window.innerWidth,
      height: window.innerHeight
    }, this.ticker.bind(this));

    var loader = new PIXI.Loader();

    loader.add('cheese', 'http://playboxcade-prod-pbccontentprod432e22c0-n8byifyfacxx.s3-website-eu-west-1.amazonaws.com/images/placeholder.png');
    layer1.spritesheets.forEach( (spritesheet) => {
      loader.add(spritesheet, 'http://playboxcade-prod-pbccontentprod432e22c0-n8byifyfacxx.s3-website-eu-west-1.amazonaws.com/spritesheets/' + spritesheet);
    });

    loader.add('http://playboxcade-prod-pbccontentprod432e22c0-n8byifyfacxx.s3-website-eu-west-1.amazonaws.com/spritesheets/voxelTiles_sheet2.json');

    //loader.add('video1', 'http://playboxcade-next-pbccontentnext6373d11d-1jk30yops1pkh.s3-website-eu-west-1.amazonaws.com/videos/placeholder.mp4');
    //loader.add('video2', 'http://playboxcade-next-pbccontentnext6373d11d-1jk30yops1pkh.s3-website-eu-west-1.amazonaws.com/videos/placeholder.m4v');
    //loader.add('video3', 'http://playboxcade-next-pbccontentnext6373d11d-1jk30yops1pkh.s3-website-eu-west-1.amazonaws.com/videos/placeholder-U.m4v');
    //loader.add('video4', 'http://playboxcade-next-pbccontentnext6373d11d-1jk30yops1pkh.s3-website-eu-west-1.amazonaws.com/videos/placeholder.m4v');

    loader.load((loader, resources) => {



      /*
	    var tilemap = new PIXI.tilemap.CompositeRectTileLayer(0, [resources['atlas_image'].texture]);
      var size = 32;
      // bah, im too lazy, i just want to specify filenames from atlas
      for (var i=0;i<7;i++)
        for (var j=0;j<7;j++) {
          tilemap.addFrame("tileBlue_01.png", i*size, j*size);
          if (i%2==1 && j%2==1)
            tilemap.addFrame("tileBlue_07.png", i*size, j*size);
        }

      // if you are lawful citizen, please use textures from the loader
      var textures = resources.atlas.textures;
      tilemap.addFrame(textures["tileBlue_03.png"], 2*size, 2*size);
      tilemap.addFrame(textures["tileBlue_21.png"], 2*size, 3*size);

      //this.pixiApp.renderer.render(tilemap);
      this.pixiApp.stage.addChild(tilemap);
      */

      /*
      const layer = new PbcLayer(resources, layer1);

      layer.scale.x = 0.5;
      layer.scale.y = 0.5;
      layer.update();
      */

      const container = new PIXI.Container();
      this.pixiApp.stage.addChild(container);

      const graphics = new PIXI.Graphics();
      graphics.beginFill(0xff0000);
      graphics.drawRect(-50,-50,100,100);
      graphics.endFill();
      container.position.set(70,70);
      container.addChild(graphics);

      console.log('resources', resources);

      const frames = [
        'voxelTile_01.png',
        'voxelTile_02.png',
        'voxelTile_03.png',
        'voxelTile_04.png',
        'voxelTile_05.png',
        'voxelTile_06.png',
        'voxelTile_07.png',
        'voxelTile_08.png',
      ];
      //const sprite = new PIXI.Sprite(resources["voxelTiles_sheet2.json"].textures['voxelTile_02.png']);
      const sprite = PIXI.AnimatedSprite.fromFrames(frames.map( (frame) => {
        return frame;
      }));
      sprite.position.set(200,200);
      sprite.animationSpeed = 0.05;
      sprite.loop = true;
      sprite.play();
      sprite.onComplete = (a,b,c) => {
        console.log('completed!',a,b,c);
      }
      sprite.onFrameChange = (a,b,c) => {
        console.log('frame change',a,b,c);
      }
      sprite.onLoop = (a,b,c) => {
        console.log('looping',a,b,c);
      }
      container.addChild(sprite);

      console.log('resources', resources);

      let i = 0;
      //['video1','video2','video3','video4'].forEach( (videoname) => {
      /*
      ['video1'].forEach( (videoname) => {
        const video = resources[videoname]
        console.log('video', video);
        const videoTexture = PIXI.Texture.from(video.data);
        console.log('videoTexture', videoTexture);
        const controller = videoTexture.baseTexture.resource.source;
        controller.loop = true;
        const sprite = new PIXI.Sprite(videoTexture);
        sprite.position.set(i*100,i*100);
        sprite.scale.set(0.3, 0.3);
        i++;

        container.addChild(sprite);
      });
      */

      const sizes = [36, 42, 64, 128];
      const textes = [
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ",
        "Lorem Ipsum is simply dummy"
      ]
      
      let k = 0;
      textes.forEach( (text) => {
        sizes.forEach( (size) => {
          const defaultOpts = {
            size
          };

          /*
          const t = new PIXI.Text(text, {
            //fontFamily: 'Arial',
            fontSize:size,
            //wordWrap:true,
            //wordWrapWidth:600,
            fill:'#ffffff'
          });
          */

          const t = util.makeStyledText({}, text, defaultOpts);
          t.position.set(0, k * 60);
          container.addChild(t);
          k++;
        });
      });
      //const longText = "Lorem Ipsum is simply"
      /*
      const t = new PIXI.Text(longText, {
        fontFamily: 'Arial',
        fontSize:36,
        wordWrap:true,
        wordWrapWidth:600,
        fill:'#ffffff'
      });
      t.scale.set(1,1);
      */

      //const boundingBox = {};
      //const {} = util.makeFittedText({},
        //"a very long string",
        //boundingBox,
        
      this.pixiApp.start();
    });

  },
  methods:{
    ticker() {
    }
  }
}
</script>
